import { c as _c } from "react/compiler-runtime";
import React from 'react';
const PaymentSettingsSkeleton = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[44px] lg:flex-row lg:gap-10"><div className="bg-skeleton-primary my-2 rounded-sm py-1 text-transparent lg:py-0">.</div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[44px] lg:flex-row lg:gap-10"><div className="bg-skeleton-primary my-2 rounded-sm py-1 text-transparent lg:py-0">.</div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="bg-background-secondary flex h-fit w-full flex-col gap-5 overflow-x-hidden rounded-md"><div className="flex animate-pulse flex-col gap-7 p-5 lg:gap-10 ">{t0}{t1}<div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[504px] lg:flex-row lg:gap-10"><div className="bg-skeleton-primary my-2 rounded-sm py-1 text-transparent lg:py-0">.</div></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default PaymentSettingsSkeleton;